module.exports = __webpack_public_path__ + "img/photo-08.54b796cc.jpg";